// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BEBaseElement } from './BEBaseElement';
import { EnumServiceActionType } from '../../../../../com/MetaPattern/MDA/MD/EntityModel/EnumServiceActionType';
import { EnumHTTPMethod } from '../../../../../com/MetaPattern/MDA/MD/EntityModel/EnumHTTPMethod';
import { EnumNetworkProtocol } from '../../../../../com/MetaPattern/MDA/MD/EntityModel/EnumNetworkProtocol';
import { BEService } from './BEService';
import { BEBusinessLogic } from './BEBusinessLogic';
import { BEExternalService } from './BEExternalService';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 服务操作 实体类
 * 服务操作
 */
export class BEServiceAction extends BEBaseElement {
  /** 服务操作类别 : 服务操作类别 */
  private _serviceActionType: EnumServiceActionType;

  /** 设置：服务操作类别 */
  public get serviceActionType() {
    return this._serviceActionType;
  }

  /** 获取：服务操作类别 */
  public set serviceActionType(value: EnumServiceActionType) {
    this._serviceActionType = value;
  }

  /** HTTP谓词 : HTTP谓词，当暴露为服务时有效 */
  private _httpMethod: EnumHTTPMethod;

  /** 设置：HTTP谓词 */
  public get httpMethod() {
    return this._httpMethod;
  }

  /** 获取：HTTP谓词 */
  public set httpMethod(value: EnumHTTPMethod) {
    this._httpMethod = value;
  }

  /** 网络协议 : 网络协议 */
  private _networkProtocol: EnumNetworkProtocol;

  /** 设置：网络协议 */
  public get networkProtocol() {
    return this._networkProtocol;
  }

  /** 获取：网络协议 */
  public set networkProtocol(value: EnumNetworkProtocol) {
    this._networkProtocol = value;
  }

  /** 服务 的ID */
  private _service_ID: string;

  /** 获取：服务 的ID */
  public get service_ID() {
    return this._service_ID;
  }

  /** 设置：服务 的ID */
  public set service_ID(value: string) {
    this._service_ID = value;
  }

  /** 服务  */
  private _service: BEService;

  /** 获取：服务  */
  public get service() {
    return this._service;
  }

  /** 设置：服务  */
  public set service(value: BEService) {
    this._service = value;
    if (value !== null) {
      this.service_ID = value.id;
    } else {
      this.service_ID = '';
    }
  }

  /** 商业逻辑 的ID */
  private _businessLogic_ID: string;

  /** 获取：商业逻辑 的ID */
  public get businessLogic_ID() {
    return this._businessLogic_ID;
  }

  /** 设置：商业逻辑 的ID */
  public set businessLogic_ID(value: string) {
    this._businessLogic_ID = value;
  }

  /** 商业逻辑  */
  private _businessLogic: BEBusinessLogic;

  /** 获取：商业逻辑  */
  public get businessLogic() {
    return this._businessLogic;
  }

  /** 设置：商业逻辑  */
  public set businessLogic(value: BEBusinessLogic) {
    this._businessLogic = value;
    if (value !== null) {
      this.businessLogic_ID = value.id;
    } else {
      this.businessLogic_ID = '';
    }
  }

  /** 外部服务 的ID */
  private _externalService_ID: string;

  /** 获取：外部服务 的ID */
  public get externalService_ID() {
    return this._externalService_ID;
  }

  /** 设置：外部服务 的ID */
  public set externalService_ID(value: string) {
    this._externalService_ID = value;
  }

  /** 外部服务  */
  private _externalService: BEExternalService;

  /** 获取：外部服务  */
  public get externalService() {
    return this._externalService;
  }

  /** 设置：外部服务  */
  public set externalService(value: BEExternalService) {
    this._externalService = value;
    if (value !== null) {
      this.externalService_ID = value.id;
    } else {
      this.externalService_ID = '';
    }
  }

  constructor() {
    super();
    this._serviceActionType = EnumServiceActionType.BusinessLogic;
    this._httpMethod = EnumHTTPMethod.GET;
    this._networkProtocol = EnumNetworkProtocol.HTTPS;
    this._service_ID = '';
    this._service = null;
    this._businessLogic_ID = '';
    this._businessLogic = null;
    this._externalService_ID = '';
    this._externalService = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: BEServiceAction, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.serviceActionType = element.serviceActionType;
      this.httpMethod = element.httpMethod;
      this.networkProtocol = element.networkProtocol;
      this.service_ID = element.service_ID;
      if (hasReference && element.service !== null) {
        this.service = element.service;
      }
      this.businessLogic_ID = element.businessLogic_ID;
      if (hasReference && element.businessLogic !== null) {
        this.businessLogic = element.businessLogic;
      }
      this.externalService_ID = element.externalService_ID;
      if (hasReference && element.externalService !== null) {
        this.externalService = element.externalService;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.serviceActionType = json.ServiceActionType as EnumServiceActionType;
    this.httpMethod = json.HttpMethod as EnumHTTPMethod;
    this.networkProtocol = json.NetworkProtocol as EnumNetworkProtocol;
    this.service_ID = json.Service_ID;
    // if (json.Service !== null) {
    //   this.service = BEService.Create(json.Service);
    // }
    this.businessLogic_ID = json.BusinessLogic_ID;
    // if (json.BusinessLogic !== null) {
    //   this.businessLogic = BEBusinessLogic.Create(json.BusinessLogic);
    // }
    this.externalService_ID = json.ExternalService_ID;
    // if (json.ExternalService !== null) {
    //   this.externalService = BEExternalService.Create(json.ExternalService);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.ServiceActionType = this.serviceActionType;
    json.HttpMethod = this.httpMethod;
    json.NetworkProtocol = this.networkProtocol;
    json.Service_ID = this.service_ID;
    json.BusinessLogic_ID = this.businessLogic_ID;
    json.ExternalService_ID = this.externalService_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('服务', 'httpMethod', 'HTTP谓词', EnumDataType.Reference, this.httpMethod, true, 'HTTP谓词，当暴露为服务时有效', 'EnumHTTPMethod', 'PGRowEnumValue');
    context.addRow('服务', 'networkProtocol', '网络协议', EnumDataType.Reference, this.networkProtocol, true, '网络协议', 'EnumNetworkProtocol', 'PGRowEnumValue');
    context.addRow('引用', 'businessLogic', '商业逻辑', EnumDataType.Reference, this.businessLogic, true, '', 'BEBusinessLogic', 'PGRowBusinessLogicValue');
    context.addRow('引用', 'externalService', '外部服务', EnumDataType.Reference, this.externalService, true, '', 'BEExternalService', 'PGRowExternalServiceValue');
    return context;
  }

  static Create(json: any): BEServiceAction {
    const bEServiceAction = new BEServiceAction();
    bEServiceAction.Deserialize(json);
    bEServiceAction.json = json;
    return bEServiceAction;
  }
}
